import { render, staticRenderFns } from "./_base-modal.vue?vue&type=template&id=19b5434c&scoped=true&"
import script from "./_base-modal.vue?vue&type=script&lang=js&"
export * from "./_base-modal.vue?vue&type=script&lang=js&"
import style0 from "./_base-modal.vue?vue&type=style&index=0&id=19b5434c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b5434c",
  null
  
)

export default component.exports